/**
 * @name store/modules/signup/index.js
 * @module app
 *
 * @description
 * The typescript store modules.
 *
 * @project spotgig4app
 * @author hyugayuki on 2020/02/25
 * Copyright © 2017年 Axis-motion. All rights reserved.
 */

import Nationality from '@/api/nationality';
import Industries from '@/api/v1/industries';
import Occupations from '@/api/v1/occupations';
import * as types from './mutation-types';

const state = {
  nationalities: [],
  industries: [],
  occupations: []
}

const getters = {
  nationalities: state => state.nationalities,
  industries: state => state.industries,
  occupations: state => state.occupations
}
　
const actions = {
  fetchNationalities({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      Nationality.getAll(params, response => {
        if ( Object.keys(response.data.errors).length === 0 ) {
          commit(types.SET_NATIONALITIES, response.data.payload);
          resolve(response);
        } else {
          reject(response.data.errors);
        }
      }).catch(reject);
    });
  },
  fetchIndustries({ commit, state }, params) {
    return new Promise((resolve, reject) => {
      Industries.getAll(params, response => {
        if (response.status === 200) {
          commit(types.SET_INDUSTRIES, response.data.payload);
          resolve(response);
        } else {
          reject(response.data.errors);
        }
      }).catch(reject);
    });
  },
  fetchOccupations({ commit }, params) {
    return new Promise((resolve, reject) => {
      Occupations.getAll(params, (response) => {
        if (response.status === 200) {
          commit(types.SET_OCCUPATIONS, response.data.payload);
          resolve(response);
        } else {
          reject(response.data.errors);
        }
      }).catch(reject);
    });
  },
}

const mutations = {
  [types.SET_NATIONALITIES] (state, payload) {
    state.nationalities = payload;
  },
  [types.SET_INDUSTRIES] (state, payload) {
    state.industries = payload;
  },
  [types.SET_OCCUPATIONS] (state, payload) {
    state.occupations = payload;
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
